'use strict';

var Facade = require('./facade');

Facade.Alias = require('./alias');
Facade.Group = require('./group');
Facade.Identify = require('./identify');
Facade.Track = require('./track');
Facade.Page = require('./page');
Facade.Screen = require('./screen');
Facade.Delete = require('./delete');

module.exports = Facade;



//////////////////
// WEBPACK FOOTER
// ./~/segmentio-facade/lib/index.js
// module id = 131
// module chunks = 0